import { getInteractionsFromTopicAndState } from 'selectors/block';
import { Action, initialState, State } from 'store/store';

export const updateInteractionsLocked = (
  state: State = initialState,
  { data }: Action
): State => {
  const { id } = data;
  const { interactionsLocked } = state;
  const updatedInteractionsLocked = [...interactionsLocked];

  const indexOfId = updatedInteractionsLocked.indexOf(id);
  // console.log(id, interactionsLocked, indexOfId);

  if (indexOfId !== -1) {
    updatedInteractionsLocked.splice(indexOfId, 1);
  }

  return {
    ...state,
    interactionsLocked: updatedInteractionsLocked,
  };
};
